export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-white shadow-sm text-gray-900">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-8 sm:py-10 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          <div className="col-span-1 sm:col-span-2 lg:col-span-2">
            <div className="flex items-center mb-3 sm:mb-4 -ml-6 sm:-ml-7">
              <img
                src="/images/logos/app-logo2.png"
                alt="Pamag Healthcare Services LLC Icon"
                className="h-14 sm:h-16 md:h-18 lg:h-20 w-auto"
              />
              <span className="-ml-6 sm:-ml-7 md:-ml-8 lg:-ml-9 self-center text-base sm:text-lg md:text-xl lg:text-xl xl:text-xl font-extrabold tracking-wide bg-gradient-to-r from-emerald-700 via-emerald-600 to-teal-600 bg-clip-text text-transparent whitespace-nowrap leading-none drop-shadow-sm">
                PAMAG HEALTH CARE SERVICES LLC
              </span>
            </div>
            <p className="text-gray-600 mb-4 sm:mb-6 max-w-md text-sm sm:text-base">
              Dedicated to providing exceptional healthcare services with
              compassion, expertise, and innovation. Your health and well-being
              are our top priorities.
            </p>
            {/* Social Media Icons - Commented Out */}
            {/* <div className="flex space-x-3 sm:space-x-4">
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-600 rounded-full cursor-pointer hover:bg-teal-700 transition-colors">
                <i className="ri-facebook-fill text-gray-900 text-sm sm:text-base"></i>
              </div>
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-600 rounded-full cursor-pointer hover:bg-teal-700 transition-colors">
                <i className="ri-twitter-fill text-gray-900 text-sm sm:text-base"></i>
              </div>
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-600 rounded-full cursor-pointer hover:bg-teal-700 transition-colors">
                <i className="ri-linkedin-fill text-gray-900 text-sm sm:text-base"></i>
              </div>
              <div className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center bg-teal-600 rounded-full cursor-pointer hover:bg-teal-700 transition-colors">
                <i className="ri-instagram-fill text-gray-900 text-sm sm:text-base"></i>
              </div>
            </div> */}
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-gray-900">
              Quick Links
            </h4>
            <ul className="space-y-1 sm:space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection("home")}
                  className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-sm sm:text-base"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("services")}
                  className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-sm sm:text-base"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("about")}
                  className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-sm sm:text-base"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("contact")}
                  className="text-gray-700 hover:text-teal-600 cursor-pointer transition-colors text-sm sm:text-base"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 text-gray-900">
              Contact Info
            </h4>
            <div className="space-y-2 sm:space-y-3">
              <div className="flex items-center">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2 sm:mr-3">
                  <i className="ri-phone-line text-teal-400 text-sm sm:text-base"></i>
                </div>
                <span className="text-gray-700 text-sm sm:text-base">
                  (617) 765-5275
                </span>
              </div>
              <div className="flex items-center">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2 sm:mr-3">
                  <i className="ri-mail-line text-teal-400 text-sm sm:text-base"></i>
                </div>
                <span className="text-gray-700 text-xs sm:text-sm break-all">
                  pamaghealthcareservices@gmail.com
                </span>
              </div>
              <div className="flex items-start">
                <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center mr-2 sm:mr-3 mt-1">
                  <i className="ri-map-pin-line text-teal-400 text-sm sm:text-base"></i>
                </div>
                <span className="text-gray-700 text-sm sm:text-base">
                  Washington Street, Suite 12
                  <br />
                  Dorchester 02124 MA
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-6 sm:mt-8 pt-6 sm:pt-8">
          <p className="text-gray-400 text-xs sm:text-sm text-center">
            © 2025 Pamag Healthcare Services LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
